<template>
  <div class="fit-content">
    <div>
      <DataTableDeCrud
        :items="ipis"
        :headers="headers"
        :rotina-id="ID_TELA_DE_IPI"
        :configurar="false"
        :loading="loading"
        :busca-param="buscaParam"
        @create="() => abrirDialogCriarIPI()"
        @update="(indice) => abrirDialogEditarIPI(indice)"
        @delete="(indice) => openDialogDeleteIPI(indice)"
      >
        <template #[`item.aliquota`]="{ item }">
          <span>
            {{ formatNumber(item.aliquota) }}
          </span>
        </template>
      </DataTableDeCrud>

      <DialogDeEdicaoDeIPI
        :operacao="operacao"
        :show-dialog.sync="showDialogParam"
        :ipi-param="ipiParam"
        :itens="itensParam"
        @confirmado="atualizarIPI"
      />

      <SnackbarMessage
        :show-snack.sync="snackbar.showSnackParam"
        :snack-text="snackbar.snackTextParam"
        :snack-type="snackbar.snackTypeParam"
      />

      <v-dialog v-model="dialogDeleteIpi" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text refs="ipiDelete">
            Tem certeza que deseja excluir o ipi <b> {{ ipiDelete.descricao }} </b>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogDeleteIpi = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="removerIPI">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import IPIService from '@/services/ipi/ipi'
import NCMService from '@/services/ncm/ncm'
import CSTService from '@/services/cst/cst'
import SnackbarMessage from '@/components/SnackbarMessage'
import DialogDeEdicaoDeIPI from '@/components/ipi/DialogDeEdicaoDeIPI'
import DataTableDeCrud from '@/components/DataTableDeCrud'
import SnackBar from '@/models/components/snackbar'
import IPI from '@/models/ipi'
import { ID_TELA_DE_IPI } from '@/common/constants'
import { formatNumber } from '@/shareds/formatacoes'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeEdicaoDeIPI
  },

  props: ['buscaParam'],

  data: () => ({
    name: 'TelaDeIPI',
    headers: [
      { text: 'NCM', value: 'ncm.descricao' },
      { text: 'Descrição', value: 'descricao' },
      { text: 'CST', value: 'cst' },
      { text: 'Alíquota IPI', value: 'aliquota' },
      { text: 'Observação', value: 'observacao' }
    ],
    ipis: [],
    loading: false,
    validForm: false,
    dialog: false,
    operacao: '',
    showDialogParam: false,
    ipiParam: new IPI(),
    itensParam: {},
    snackbar: new SnackBar(),
    dialogDeleteIpi: false,
    ipiDelete: new IPI(),
    indiceIpiDelete: 0,
    itensCST: [],
    itensNCM: [],
    ID_TELA_DE_IPI: ID_TELA_DE_IPI,
    formatNumber: formatNumber
  }),

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      try {
        if (this.$route.query.id) {
          IPIService.getById(this.$route.query.id).then((response) => this.ipis.push(response))
        } else {
          this.loadIPIs()
        }

        this.loadNCMs()
        this.loadCSTs()
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar TipoICMSs cadastradas.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async loadIPIs() {
      this.loading = true

      this.ipis = await IPIService.getAll()

      this.loading = false
    },

    async loadNCMs() {
      const response = await NCMService.getAll()
      this.itensNCM = response.map((item) => ({
        text: item.codigo + ' - ' + item.descricao,
        value: item.id
      }))
    },

    async loadCSTs() {
      const response = await CSTService.getAll()
      this.itensCST = response.map((item) => ({
        text: item.codigo + ' - ' + item.descricao,
        value: item.id
      }))
    },

    atualizarIPI(ipi) {
      if (!ipi) return

      const indice = this.ipis.findIndex((ipiExistente) => ipiExistente.id === ipi.id)
      if (indice === -1) {
        this.ipis.push(ipi)
        this.snackbar.snackTextParam = 'IPI criado com sucesso.'
      } else {
        this.ipis.splice(indice, 1, ipi)
        this.snackbar.snackTextParam = 'IPI atualizado com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    openDialogDeleteIPI(indice) {
      this.ipiDelete = this.ipis[indice]
      if (!this.ipiDelete.id) return

      this.indiceIpiDelete = indice
      this.dialogDeleteIpi = true
    },

    async removerIPI() {
      try {
        await IPIService.deleteById(this.ipiDelete.id)
        this.snackbar.snackTextParam = 'IPI removido com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.ipis.splice(this.indiceIpiDelete, 1)
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogDeleteIpi = false
    },

    abrirDialogCriarIPI() {
      this.operacao = 'adicionar'
      this.itensParam = { cst: this.itensCST, ncm: this.itensNCM }
      this.ipiParam = new IPI()
      this.showDialogParam = true
    },

    abrirDialogEditarIPI(indice) {
      this.operacao = 'editar'
      this.itensParam = { cst: this.itensCST, ncm: this.itensNCM }
      this.ipiParam = { ...this.ipis[indice] }
      this.showDialogParam = true
    }
  }
}
</script>
